import * as yup from "yup";

const bookingItemValidationSchema = yup.object().shape({
    accommodationUnit: yup
        .object()
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),
    price: yup
        .number()
        .nullable()
        .positive('Deve essere un numero positivo')
        .typeError('Deve essere un numero'),

});

export default bookingItemValidationSchema;